'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextYear;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isNextYear.js